<template>
<div>
  <el-dialog title="选择流程节点" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
    <div class="table-wrap">
    <el-table
      :data="list"
      border
      style="width: 100%">
      <el-table-column label="流程节点" prop="node_name">
      </el-table-column>
<!--      <el-table-column label="操作人" prop="user_name">-->
<!--      </el-table-column>-->
<!--      <el-table-column label="审批意见" prop="comments">-->
<!--      </el-table-column>-->
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button  type="danger" size="mini" @click="selectItem(scope.row)">退回到此步</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  </el-dialog>
</div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "NodeProcessSteps",
  props:{
    task_id:{
      type:String,
      default(){
        return '';
      }
    }
  },
  data(){
    return{
      dialogVisible:false,
      list:[]
    }
  },
  activated() {
    // this.getList()
  },
  methods:{
    show(config,callback){
      const that = this;
      that.dialogVisible=true;
      that.callback=callback;
      Http.get("flow/FlowProcessSteps/getNodeProcessStep",config,function (res) {
        console.info(res)
        if (res.code) {
          that.list = res.data
        }
      })
    },
    selectItem(data){
      const that = this;
      typeof that.callback==="function"&&that.callback(data)
      that.dialogVisible=false;
      that.callback=undefined;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../common";
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/NodeProcessSteps.vue